/**
 * Computes the popup position according to the input dimensions ensuring the left position
 * is shifted to the left only in the case the input is not already in the minimum left inside the overlay,
 * meaning the left can never be negative. Moreover, once it is shifted to the left offset, the width is increased
 * with the same lag to match the end of the input.
 *
 * @param inputDimensions The input dimensions
 * @param offset The left offset of the popup
 */
export function computePopupPosition(inputDimensions, offset = 40) {
  const left = inputDimensions.left - offset;
  return Object.assign(Object.assign({}, inputDimensions), { top: inputDimensions.top + inputDimensions.height, left: left <= 0 ? inputDimensions.left : left, width: left <= 0 ? inputDimensions.width : inputDimensions.width + offset });
}
//# sourceMappingURL=popup.utils.js.map
